import { gql } from '@apollo/client';

export const GetShareLinkQueryName = 'GetShareLink';

export const GET_SHARE_LINK_QUERY = gql`
  query ${GetShareLinkQueryName}($mapSettings: MapSettingsInput!, $markerPoints: [MarkerPointInput!]) {
    getShareLink(mapSettings: $mapSettings, markerPoints: $markerPoints)
  }
`;
